export enum DetailTab {
  Overview = 'overview',
  Amortization = 'amortization',
}

export interface DetailTabToggleProps {
  selectedTab: DetailTab
  onTabChange: (tab: DetailTab) => void
}
